<template>
  <ul v-if="planSignUpInfo">
    <template v-if="planSignUpInfo.type == 0">
      <li v-if="planSignUpInfo.list[0]">
        <p>本期剩余席位</p>
        <p>{{planSignUpInfo.list[0].totalnum - planSignUpInfo.list[0].artualnum}}</p>
      </li>
      <li v-if="planSignUpInfo.list[0]">
        <p>本期{{planSignUpInfo.list[0].stateStr}}时间</p>
        <p>{{planSignUpInfo.list[0].showTime}}</p>
      </li>
      <li v-if="planSignUpInfo.list[1]">
        <p>下期{{planSignUpInfo.list[1].stateStr}}时间</p>
        <p>{{planSignUpInfo.list[1].showTime}}</p>
      </li>
    </template>
    <template v-if="planSignUpInfo.type == 1">
      <template v-if="planSignUpInfo.fullList">
        <li v-for="(full, fullIndex) in planSignUpInfo.fullList" :key="fullIndex">
          <p>{{full.showTime}}开课</p>
          <p>已爆满</p>
        </li>
      </template>
      <li v-if="planSignUpInfo.list[0]">
        <p>下期{{planSignUpInfo.list[0].stateStr}}时间</p>
        <p>{{planSignUpInfo.list[0].showTime}}</p>
      </li>
    </template>
    <li v-if="!planSignUpInfo.list.length && !planSignUpInfo.fullList.length">
      <p>本期开班</p>
      <p>已爆满</p>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['lessonInfo', 'signUpInfo'],
  data () {
    return {
      planSignUpInfo: null
    }
  },
  methods: {
    getSignUpInfo () {
      if (!this.lessonInfo || !this.lessonInfo.classinfo.length) {
        return false
      }
      let currentTime = new Date().getTime()
      let signUpList = []
      let nextSignUpList = []
      let fullList = []
      for (let v of this.lessonInfo.classinfo) {
        let signUpTime = v.bfromtime * 1000
        let signEndTime = v.btotime * 1000
        let startTime = v.fromtime * 1000
        if (signUpTime < currentTime && currentTime < signEndTime) {
          v.state = 0
          v.stateStr = '开班'
          v.showTime = `${new Date(startTime).getMonth() + 1}月${new Date(startTime).getDate()}日`
          if (parseInt(v.artualnum) >= parseInt(v.totalnum)) {
            fullList.push(v)
          } else {
            signUpList.push(v)
          }
        } else if (signUpTime > currentTime) {
          v.state = 1
          v.stateStr = '报名'
          v.showTime = `${new Date(signUpTime).getMonth() + 1}月${new Date(signUpTime).getDate()}日`
          if (parseInt(v.artualnum) >= parseInt(v.totalnum)) {
            fullList.push(v)
          } else {
            nextSignUpList.push(v)
          }
        }
      }

      // 排序
      signUpList.sort((a, b) => {
        return a.bfromtime > b.bfromtime
      })
      nextSignUpList.sort((a, b) => {
        return a.bfromtime > b.bfromtime
      })
      fullList.sort((a, b) => {
        return a.bfromtime > b.bfromtime
      })

      //
      if (signUpList.length > 1) {
        signUpList.length = 2
        this.planSignUpInfo = {
          type: 0,
          list: signUpList
        } 
      } else if (signUpList.length == 1) {
        if (nextSignUpList.length) {
          signUpList.push(nextSignUpList.shift())
        }
        this.planSignUpInfo = {
          type: 0,
          list: signUpList
        }
      } else {
        if (nextSignUpList.length) {
          nextSignUpList = nextSignUpList.sort((a, b) => {
            return parseInt(a.bfromtime) - parseInt(b.bfromtime)
          })
          signUpList.push(nextSignUpList[0])
        }
        if (fullList.length > 2) {
          fullList = fullList.slice(-2)
        }
        this.planSignUpInfo = {
          type: 1,
          list: signUpList,
          fullList: fullList
        }
      }

      this.$emit('update:signUpInfo', this.planSignUpInfo)
    },
  },
  mounted () {
    this.getSignUpInfo()
  },
  watch: {
    lessonInfo () {
      this.getSignUpInfo()
    }
  }
}
</script>

<style>

</style>
